import { Chip } from '@mui/material';

interface PatientSourceChipProps {
  name: string;
  isPrimary: boolean;
  color: string;
}

export function PatientSourceChip({ name, isPrimary, color }: PatientSourceChipProps) {
  return (
    <Chip
      label={isPrimary ? `${name} (Primary)` : name}
      size="small"
      sx={{
        height: 22,
        fontSize: '0.7rem',
        fontWeight: isPrimary ? 600 : 400,
        backgroundColor: `${color}18`,
        color,
        borderColor: `${color}40`,
        border: '1px solid',
      }}
    />
  );
}
